import { render, staticRenderFns } from "./AuthStep.vue?vue&type=template&id=0f631118"
import script from "./AuthStep.vue?vue&type=script&lang=ts"
export * from "./AuthStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports